import { Component, Input, ElementRef, ViewChild, OnInit, EventEmitter, Output } from '@angular/core';

//declare const html2pdf: any;
import html2pdf from 'html2pdf.js';


@Component({
  selector: 'app-facture',
  templateUrl: './facture.component.html',
  styleUrls: ['./facture.component.css']
})
export class FactureComponent {
  @Input() customer: any;
  @Input() items: any[] = [];
  @Input() allQtsOnCart: any[] = [];
  @Input() factureId: string = '';
  @Input() date: string = new Date().toLocaleDateString();
  @ViewChild('factureContent') factureContent!: ElementRef;

  @Output() factureRetourInfoEvent = new EventEmitter<any>();

  @Input() montantrecu: any ;


  get total(): number {
    return this.items.reduce((sum, item, index) => sum + this.allQtsOnCart[index] * item.prix, 0);
  }

  imprimer() {
    this.factureContent.nativeElement.print();
  }

  imprimerSection() {
    const printContent = this.factureContent.nativeElement.innerHTML;
    const WindowPrt = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
    if (WindowPrt) {
      WindowPrt.document.write(`
        <html>
          <head>
            <title>Facture</title>
            <style>
              body { font-family: Arial, sans-serif; padding: 20px; }
              table { width: 100%; border-collapse: collapse; }
              th, td { padding: 8px; border: 1px solid #ddd; text-align: left; }
              h2, h3, p { margin: 0 0 10px; }
            </style>
          </head>
          <body onload="window.print(); window.close()">
            ${printContent}
          </body>
        </html>
      `);
      WindowPrt.document.close();
    }
  }

  formatMoney(montant: any){
    let dollarUSLocale = Intl.NumberFormat('fr-FR');
    return dollarUSLocale.format(montant) ;
  }

  exporterPDF() {
    const options = {
      margin:       10,
      filename:     `facture-${this.factureId}.pdf`,
      /*image:        { type: 'jpeg', quality: 0.98 },*/
      html2canvas:  { scale: 2 },
      jsPDF:        { unit: 'mm', format: 'a4', orientation: 'portrait' }
    };

    html2pdf().from(this.factureContent.nativeElement).set(options).save();
  }

  getRestant(){
    return Number(this.total) - Number(this.montantrecu) ;
  }
  



  fermerLeProcessusDeCommande() {
    this.factureRetourInfoEvent.emit(1);
  }



}
